import React, { ChangeEvent, useEffect, useState } from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";
import { Button, Col, Image, Row } from "react-bootstrap";
import {
  Editor,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnBulletList,
  BtnLink,
  EditorProvider,
  BtnStrikeThrough,
  ContentEditableEvent,
} from "react-simple-wysiwyg";
import { JobData } from "../../types";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../app/store";
import {
  addJob,
  getJobTypes,
  getQuestionCategory,
  getQuestions,
  getSalaryTypes,
} from "../../features/jobSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { PuffLoader } from "react-spinners";

const CreateJobs = () => {
  //state to divide the page into two
  const [currentPart, setCurrentPart] = useState(1);

  //get categories and jobs
  const { questionCategory, questions, salaryTypes, jobTypes, isLoading } =
    useAppSelector((state) => state.job);
  const navigate = useNavigate();

  const [textBoxes, setTextBoxes] = useState<string[]>([""]); // Initial state with one text box

  //keep track of selected category
  const [textBoxes1, setTextBoxes1] = useState<string[]>([""]);

  // State to store the questions selected by the user under each category
  const [selectedQuestions, setSelectedQuestions] = useState<any>([]);

  // State to store available questions for each category
  const [availableQuestions, setAvailableQuestions] = useState<any>({});

  // Handle category change and fetch questions
  const handleChangeCat = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    const categoryId = e.target.value;

    // Update the selected category in the state
    const updatedTextBoxes1 = [...textBoxes1];
    updatedTextBoxes1[index] = categoryId;
    setTextBoxes1(updatedTextBoxes1);

    // Dispatch an action to fetch questions based on the selected category
    dispatch(getQuestions(categoryId))
      .unwrap() // Unwrap the promise from the Redux thunk
      .then((response) => {
        // Assuming `response` contains the questions fetched for the category
        setAvailableQuestions((prev: any) => ({
          ...prev,
          [index]: response, // Store the fetched questions for the selected category
        }));
      })
      .catch((error) => {
        // Handle any errors here (optional)
        console.error("Error fetching questions: ", error);
      });
  };

  const addTextBox = () => {
    setTextBoxes((prevTextBoxes) => [...prevTextBoxes, ""]);
  };

  // Function to handle the removal of a text box
  const removeTextBox = (index: number) => {
    setTextBoxes((prevTextBoxes) =>
      prevTextBoxes.filter((_, i) => i !== index)
    );
  };

  const addTextBox1 = () => {
    setTextBoxes1((prevTextBoxes1) => [...prevTextBoxes1, ""]);
  };

  // Function to handle the removal of a text box
  const removeTextBox1 = (index: number) => {
    setTextBoxes1((prevTextBoxes1) =>
      prevTextBoxes1.filter((_, i) => i !== index)
    );
  };

  const handleQuestionSelect = (questionId: number) => {
    setSelectedQuestions((prev: any) => {
      // Check if the questionId is already selected
      const isSelected = prev.includes(questionId);

      // Toggle the questionId in the selected questions array
      if (isSelected) {
        // If selected, remove it
        return prev.filter((id: number) => id !== questionId);
      } else {
        // If not selected, add it
        return [...prev, questionId];
      }
    });
  };

  const dispatch = useAppDispatch();

  //get question category
  useEffect(() => {
    dispatch(getQuestionCategory());
    dispatch(getJobTypes());
    dispatch(getSalaryTypes());
  }, []);

  const [formData, setFormData] = useState<JobData>({
    jobTitle: "",
    jobLocation: "",
    department: "",
    jobType: "",
    jobDescription: "",
    otherInfo: "",
    salaryType: "",
    minSalary: 0,
    maxSalary: 0,
    perHourRate: 0,
    contactEmail: "",
    contactNumberStatus: "",
    contactNumber: "",
    negotiable: "",
    jobRole: "",
    numberOfPositions: 0,
    companyName: "",
    industry: "",
    appUrl: "",
    hiringManager: "",
    openDate: undefined,
    closeDate: undefined,
    jobStatus: "",
    assignedTeam: "",
    jobCategory: "",
    jobQuestions: null,
    destination: "",
  });

  //formatting date
  const formatDate = (date: Date | undefined): string => {
    return date ? moment(date).format("YYYY-MM-DD") : "";
  };
  //handle editor
  const handleEditorChange = (
    editorName: keyof JobData,
    event: ContentEditableEvent
  ) => {
    const value = event.target.value; // Extract the HTML content
    setFormData((prevData) => ({
      ...prevData,
      [editorName]: value,
    }));
  };
  //onchange in forms
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //jobquestion
  const handleChangeJob = (index: number, value: string) => {
    setTextBoxes((prevTextBoxes) =>
      prevTextBoxes.map((textBox, i) => (i === index ? value : textBox))
    );
  };

  const handleSubmitJob = (jobStatus1: string) => {
    let data = {
      jobTitle: formData.jobTitle,
      jobLocation: formData.jobLocation,
      department: formData.department,
      jobType: formData.jobType,
      jobDescription: formData.jobDescription,
      otherInfo: formData.otherInfo,
      salaryType: formData.salaryType,
      minSalary: formData.minSalary,
      maxSalary: formData.maxSalary,
      perHourRate: formData.perHourRate,
      contactEmail: formData.contactEmail,
      contactNumberStatus: formData.contactNumberStatus,
      contactNumber: formData.contactNumber,
      negotiable: formData.negotiable,
      jobRole: formData.jobRole,
      numberOfPositions: formData.numberOfPositions,
      companyName: formData.companyName,
      industry: formData.industry,
      appUrl: formData.appUrl,
      hiringManager: formData.hiringManager,
      openDate: formData.openDate,
      closeDate: formData.closeDate,
      jobStatus: jobStatus1,
      assignedTeam: formData.assignedTeam,
      jobCategory: formData.jobCategory,
      jobQuestions: textBoxes,
      jobQuestionIds: selectedQuestions,
      destination: formData.destination,
    };

    dispatch(addJob(data))
      .unwrap()
      .then((response: any) => {
        navigate("/jobs");
        toast.success(response.message);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  if (isLoading || !questionCategory || !jobTypes || !salaryTypes) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <PuffLoader color="#36d7b7" size={60} />
      </div>
    );
  }

  return (
    <div>
      <AuthLayout>
        {" "}
        <a href="/jobs" className="text-decoration-none fw-bold text-primary">
          <i className="bi bi-arrow-left border-primary"></i> Back
        </a>
        <div className="bg-white p-3 mt-5">
          <Row>
            <h4 className="fw-bold">Create Job</h4>
            <hr className="w-100 border-blend" />

            <Col md={10} sm={12}>
              {currentPart === 1 && (
                <>
                  <h6>Enter Job Details</h6>
                  <Row>
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Job Title</label>
                        <input
                          type="text"
                          className="form-control border-dark"
                          name="jobTitle"
                          value={formData.jobTitle}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">
                          Job Location (Select City)
                        </label>
                        <select
                          className="form-select border-dark"
                          name="jobLocation" // Changed 'city' to 'jobLocation' to match formData key
                          onChange={handleChange}
                          value={formData.jobLocation}
                        >
                          <option value="" disabled>
                            Select a location
                          </option>
                          <option value="Ontario">Ontario</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Job Type</label>
                        <select
                          className="form-select border-dark"
                          name="jobType"
                          onChange={handleChange}
                          value={formData.jobType}
                        >
                          <option value="" disabled>
                            Select a job type
                          </option>
                          {jobTypes &&
                            jobTypes
                              .filter((type: any) => type.status === 1)
                              .map((type: any) => (
                                <option key={type.id} value={type.name}>
                                  {type.name}
                                </option>
                              ))}
                        </select>
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Department</label>
                        <input
                          type="text"
                          className="form-control border-dark"
                          name="department"
                          onChange={handleChange}
                          value={formData.department}
                        />
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Industry</label>
                        <input
                          type="text"
                          className="form-control border-dark"
                          name="industry"
                          onChange={handleChange}
                          value={formData.industry}
                        />
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          className="form-control border-dark"
                          name="companyName"
                          onChange={handleChange}
                          value={formData.companyName}
                        />
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">No of Positon(s)</label>
                        <input
                          type="number"
                          className="form-control border-dark"
                          name="numberOfPositions"
                          onChange={handleChange}
                          value={formData.numberOfPositions}
                        />
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">App Url</label>
                        <input
                          type="text"
                          className="form-control border-dark"
                          name="appUrl"
                          onChange={handleChange}
                          value={formData.appUrl}
                        />
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Destination</label>
                        <select
                          className="form-select border-dark"
                          name="destination"
                          onChange={handleChange}
                          value={formData.destination}
                        >
                          <option defaultValue={""} disabled>
                            Select destination
                          </option>
                          <option value="olade">Olade</option>
                          <option value="threesisters">Three Sisters</option>
                        </select>
                      </div>
                    </Col>

                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Opening Date</label>
                        <div className="input-group">
                          <span
                            className="input-group-text border-dark"
                            id="basic-addon1"
                          >
                            <i className="bi bi-calendar-plus"></i>
                          </span>
                          <input
                            type="date"
                            className="form form-control border-dark"
                            name="openDate" // Ensure this matches the key in formData
                            value={formatDate(formData.openDate ?? undefined)} // Format the date value using moment
                            onChange={handleChange} // Handle date change
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Closing Date</label>
                        <div className="input-group">
                          <span
                            className="input-group-text border-dark"
                            id="basic-addon1"
                          >
                            <i className="bi bi-calendar-plus"></i>
                          </span>
                          <input
                            type="date"
                            className="form form-control border-dark"
                            name="closeDate"
                            value={formatDate(formData.closeDate ?? undefined)}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={12} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Job Duties</label>
                        <EditorProvider>
                          <Editor
                            value={formData.jobDescription}
                            onChange={(event) =>
                              handleEditorChange("jobDescription", event)
                            }
                          >
                            <Toolbar>
                              <BtnBold />
                              <BtnItalic />
                              <BtnUnderline />
                              <BtnStrikeThrough />
                              <BtnBulletList />
                              <BtnLink />
                            </Toolbar>
                          </Editor>
                        </EditorProvider>
                      </div>
                    </Col>

                    <Col md={12} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Other Info</label>
                        <EditorProvider>
                          <Editor
                            value={formData.otherInfo}
                            onChange={(event) =>
                              handleEditorChange("otherInfo", event)
                            }
                          >
                            <Toolbar>
                              <BtnBold />
                              <BtnItalic />
                              <BtnUnderline />
                              <BtnStrikeThrough />
                              <BtnBulletList />
                              <BtnLink />
                            </Toolbar>
                          </Editor>
                        </EditorProvider>
                      </div>
                    </Col>
                    <hr className="border-blend mb-3 mt-3" />
                    <h6>Job Salary</h6>
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Salary Type</label>

                        <select
                          className="form-select border-dark"
                          name="salaryType"
                          onChange={handleChange}
                          value={formData.salaryType}
                        >
                          <option selected value={" "}>
                            Select a salary type
                          </option>
                          {salaryTypes &&
                            salaryTypes
                              .filter((type: any) => type.status === 1)
                              .map((type: any) => (
                                <option key={type.id} value={type.name}>
                                  {type.name}
                                </option>
                              ))}
                        </select>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Salary (min)</label>
                        <input
                          type="number"
                          step="any"
                          className="form-control border-dark"
                          name="minSalary"
                          onChange={handleChange}
                          value={formData.minSalary}
                        />
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">Salary (max)</label>
                        <input
                          type="number"
                          step="any"
                          className="form-control border-dark"
                          name="maxSalary"
                          onChange={handleChange}
                          value={formData.maxSalary}
                        />
                      </div>
                    </Col>
                    <hr className="border-blend mb-3 mt-3" />
                    <Col md={4} sm={12}>
                      <div className="form-group mb-3">
                        <h6>Job Category</h6>
                        <select
                          className="form-select border-dark"
                          name="jobCategory"
                          onChange={handleChange}
                          value={formData.jobCategory}
                        >
                          <option selected value={" "}>
                            Select job type
                          </option>
                          <option value="internal">Internal</option>
                          <option value="hourly">External</option>
                        </select>
                      </div>
                    </Col>
                    <hr className="border-blend mb-3 mt-3" />
                    <Col md={8} sm={12}>
                      <h6>Employee Questions</h6>
                      {textBoxes.map((textBox, index) => (
                        <>
                          <div
                            key={index}
                            className="d-flex align-items-center mb-2"
                          >
                            <input
                              type="text"
                              value={textBox}
                              onChange={(e) =>
                                handleChangeJob(index, e.target.value)
                              }
                              className="form-control me-2 rounded-0"
                            />
                          </div>
                          <div className="d-flex justify-content-between">
                            <i
                              className="bi bi-dash-circle-fill text-danger border-0"
                              onClick={() => removeTextBox(index)}
                            ></i>
                            <i
                              className="bi bi-plus-circle-fill text-secondary border-0"
                              onClick={addTextBox}
                            ></i>
                          </div>
                        </>
                      ))}
                    </Col>

                    {/* <Col md={8} sm={12}>
    Do you identify as an Aboriginal/Indigenous person who is
    First Nations, Inuit or Métis?
    <div className="d-flex justify-content-between">
      <i className="bi bi-dash-circle-fill text-danger border-0"></i>
      <i className="bi bi-plus-circle-fill text-secondary border-0"></i>
    </div>
  </Col> */}

                    <Col md={6} sm={12} className="mt-5">
                      <h6 className="text-secondary">
                        Assign Hiring Manager +
                      </h6>
                      <Button className="btn btn-outline-secondary btn-sm bg-white rounded-pill">
                        Ade Adeyemi
                      </Button>
                      <Button className="btn btn-outline-secondary btn-sm bg-white rounded-pill mx-2">
                        Lola Adeyemi
                      </Button>
                      <Button className="btn btn-outline-secondary btn-sm rounded-pill bg-white">
                        Busayo Moses
                      </Button>
                    </Col>

                    <hr className="border-blend mb-3 mt-3" />
                    <div className="d-flex justify-content-end">
                      <Button
                        className="btn btn-primary float-end w-10"
                        onClick={() => setCurrentPart(2)}
                      >
                        Next
                      </Button>
                    </div>
                  </Row>
                </>
              )}
              {currentPart === 2 && (
                <Row>
                  <Col md={8} sm={12} className="mb-3">
                    <h5>Screener Quesions</h5>
                    {textBoxes1.map((textBox1, index) => (
                      <>
                        <select
                          className="form-control rounded-0 w-100"
                          value={textBox1}
                          onChange={(e) => handleChangeCat(e, index)}
                        >
                          <option value="" disabled>
                            Select question category
                          </option>
                          {questionCategory &&
                            questionCategory.data.map((cats: any) => (
                              <option key={cats.id} value={cats.id}>
                                {cats.category_name}
                              </option>
                            ))}
                        </select>

                        {availableQuestions[index] && (
                          <div className="mt-2 w-100">
                            {availableQuestions[index].data.map(
                              (question: any) => (
                                <div key={question.id} className="mb-4 mt-4">
                                  <input
                                    type="checkbox"
                                    className="form-check-input me-3"
                                    id={`question-${question.id}`}
                                    value={question.id}
                                    onChange={() =>
                                      handleQuestionSelect(question.id)
                                    }
                                  />

                                  <label htmlFor={`question-${question.id}`}>
                                    {question.jobQuestion}
                                  </label>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        <div className="d-flex justify-content-between mb-3">
                          <i
                            className="bi bi-dash-circle-fill text-danger border-0"
                            onClick={() => removeTextBox1(index)}
                          ></i>
                          <i
                            className="bi bi-plus-circle-fill text-secondary border-0"
                            onClick={addTextBox1}
                          ></i>
                        </div>
                      </>
                    ))}
                  </Col>

                  <Col md={12} sm={12} className="mt-5">
                    <div className="d-flex justify-content-end">
                      <Button
                        className="btn btn-secondary float-end w-10 text-white me-2"
                        onClick={() => setCurrentPart(1)}
                      >
                        Previous
                      </Button>
                      <Button
                        className="btn btn-secondary btn-sm text-white"
                        onClick={() => handleSubmitJob("Saved")}
                      >
                        Save Job
                      </Button>
                      <Button
                        className="btn btn-green btn-sm  mx-2 text-white"
                        onClick={() => handleSubmitJob("Published")}
                      >
                        Publish Job
                      </Button>
                      <Button
                        className="btn btn-secondary btn-sm text-white mx-2"
                        onClick={() => handleSubmitJob("Published")}
                      >
                        Publish to Job Boards
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
            <Col md={2} sm={12} className="p-3" id="sidejob">
              <p>
                Lorem ipsum dolor sit amet consectetur. Sed lectus nulla est a.
                Ultrices suspendiss e porta senectus eleifend at sed lobortis
                convallis fusce. Egestas in felis ipsum at tellus. Neque sed
                fringilla elementum massa tristique amet volutpat.
              </p>
              <p>
                Lorem ipsum dolor sit amet consectetur. Sed lectus nulla est a.
                Ultrices suspendiss e porta senectus eleifend at sed lobortis
                convallis fusce. Egestas in felis ipsum at tellus. Neque sed
                fringilla elementum massa tristique amet volutpat.
              </p>
              <Image
                src="images/frame.png"
                className="img-fluid"
                alt="oladeimg"
                style={{ marginTop: "100%" }}
              />
            </Col>
          </Row>
        </div>
      </AuthLayout>
    </div>
  );
};

export default CreateJobs;
